import styled from 'styled-components';
import { headlineFontFamily } from 'assets/styles/fonts';

export const Headline4 = styled.h4`
  font-size: ${({ theme }) => theme.fonts.headline4FontSize};
  ${headlineFontFamily};
`;
